<main class="grow overflow-hidden">
  <div class="h-full min-h-0 border-b border-white">
    <div class="max-w-xl mx-auto pt-2 px-4 container">
      <div class="mb-4">
        <h1 class="sm:text-center">
          {{ translations['is_this_information_correct'] }}
        </h1>
      </div>
      <div class="mb-4">
        <label for="model-name">{{ translations['model_label'] }}</label>
        <input
          id="model-name"
          class="input-disable"
          type="text"
          name="model-name"
          [value]="
            isMachineSelected ? deviceData?.selectedMachineType : 'Not Sure'
          "
          readonly
        />
        <button
          type="button"
          class="icon-button"
          (click)="changeDevice()"
          aria-label="Navigate to Devices"
        >
          <img src="./assets/images/icon/arrow.png" alt="Go" />
        </button>
      </div>
      <div class="mb-4">
        <label for="account-id">{{ translations['account_label'] }}</label>
        <input
          id="account-id"
          type="text"
          name="account-id"
          class="input-disable"
          [(ngModel)]="deviceData.accountName"
          readonly
        />
      </div>
      <div class="columns-2 mb-4">
        <div>
          <label for="state">{{ translations['state'] }}</label>
          <input
            id="state"
            type="text"
            name="state"
            class="input-disable"
            [(ngModel)]="deviceData.state"
          />
        </div>
        <div>
          <label for="zip">{{ translations['zip'] }}</label>
          <input
            id="zip"
            type="text"
            name="zip"
            class="input-disable"
            [(ngModel)]="deviceData.zip"
          />
        </div>
      </div>
      <div class="d-flex justify-content-center mb-4">
        <img
          class="img-machine"
          *ngIf="machineImageUrl"
          [src]="machineImageUrl"
        />
      </div>
      <div *ngIf="isMachineSelected" class="d-flex justify-content-center pb-4">
        <button
          class="btn-machine"
          routerLink="dishmachineModel"
          (click)="changeDevice()"
        >
          <img src="./assets/images/icon/change.png" class="img-change" />
          {{ translations['change'] }}
        </button>
      </div>
    </div>
  </div>
</main>
<div class="layout-bottom">
  <div *ngIf="isBusinessHours" class="d-flex justify-content-center mx-4 mb-4">
    <p class="p">
      {{ translations['term3'] }}
      <span class="d-flex justify-content-center p">{{
        translations['term2']
      }}</span>
    </p>
  </div>
  <div *ngIf="!isBusinessHours" class="d-flex justify-content-center mx-4 mb-4">
    <p class="p">
      {{ translations['term1'] }}
      <span class="d-flex justify-content-center p">{{
        translations['term2']
      }}</span>
    </p>
  </div>
  <div class="max-w-xl mx-auto px-4 py-4 d-flex justify-content-center">
    <a
      *ngIf="!isBusinessHours"
      class="d-flex btn-blue-outline ms-1 justify-content-center a"
      href="tel:18003525326"
      (click)="navigate('contact-us')"
    >
      <img class="chatIcon" src="assets/images/icon/call.png" />
      <span class="ms-1 contact">
        {{ translations['call_ecolab'] }}
      </span>
    </a>
    <button
      *ngIf="isBusinessHours"
      class="btn-blue-outline ms-1"
      (click)="niceChat()"
    >
      <img class="chatIcon" src="assets/images/icon/chat.png" />
      <span class="ms-1">
        {{ translations['start_chat'] }}
      </span>
    </button>
  </div>
</div>
